<template>
    <div class="AboutUs">
        <!-- 企业愿景 -->
        <div class="cs-aboutUs-part1">
            <div class="container">
                <div class="con">
                    <p class="tit">企业愿景</p>
                    <p class="desc">致力于教育，整合优质资源，打造互联生态，实现共赢。</p>
                    <p class="desc">
                        创森智云致力于K12教育集团、教育机构、网络教育集团、职业学校和大学。
                    </p>
                    <p class="desc">我们的目标是成为教育行业领先的服务提供商之一。</p>
                </div>
            </div>
        </div>
        <!-- 关于我们 -->
        <div class="cs-aboutUs-part2">
            <div class="container">
                <p class="tit">关于我们</p>
                <div class="cs-aboutUs-part2-con">
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="img">
                            <img src="../assets/img/cs-aboutus-1.jpg" alt="" />
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                            <div class="con">
                                <p>
                                    江苏创森智云信息技术有限公司（以下简称“创森”）
                                    是一家专门提供教育解决方案的 Apple 优质教育合作商，公司总部设在北京，并在上海、武汉、成都、西安、苏州、杭州等地设有分公司；创森是 Apple
                                    优质商务合作商“倍升互联（北京）科技有限公司”的全资子公司，Apple 业务的员工总数超过300人。创森和倍升同是北京海开控股（集团）股份有限公司下属控股企业。
                                </p>
                                <p>
                                    截至目前，江苏创森智云信息技术有限公司已为各类教育客户提供了众多的移动解决方案，并与200多所高校、100多所职业学校、50多个教育集团进行合作。
                                </p>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>

        <div class="cs-page">
            <router-link to="home" active-class="activeClass">首页</router-link>
            <router-link to="Sustainability" active-class="activeClass">下一页</router-link>
        </div>
    </div>
</template>
<script>
export default {
    name: "AboutUs",
    data() {
        return {};
    },
    mounted() { },
    methods: {},
};
</script>
<style lang="scss">
.AboutUs {
    border-bottom: 1px solid #d6d6d6;

    // 企业愿景
    .tit {
        font-size: 40px;
        font-weight: 600;
        color: #000000;
        text-align: center;
    }

    .cs-aboutUs-part1 {
        // height: 340px;
        background: #fff;
        padding-bottom: 80px;

        .con {
            text-align: center;

            .tit {
                font-size: 40px;
                font-weight: 600;
                color: #000000;
                padding: 80px 0 18px 0;
            }

            .desc {
                font-size: 20px;
                font-weight: 400;
                color: #333333;
                line-height: 38px;
            }
        }
    }

    // 关于我们
    .cs-aboutUs-part2 {
        // height: 820px;
        background: #f5f5f7;

        .tit {
            padding: 80px 0 57px 0;
        }
        .cs-aboutUs-part2-con {
            background: #fff;
            border-radius: 22px;
            overflow: hidden;
            // height: 560px;
            margin-bottom: 80px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);

            img {
                max-width: 100%;
                float: left;
                // width: 540px;
            }

            .con {
                // width: 640px;
                padding: 30px 35px 0 0;

                p {
                    font-size: 20px;
                    font-weight: 400;
                    color: #333333;
                    line-height: 38px;

                    &:first-child {
                        margin-bottom: 10px;
                    }

                    text-align: justify;
                }
            }
        }
    }
}

// 适配
@media screen and (max-width: 992px) {
    .AboutUs .cs-aboutUs-part2 .cs-aboutUs-part2-con .img {
        text-align: center;

        img {
            float: none;
        }
    }

    .AboutUs .cs-aboutUs-part2 .cs-aboutUs-part2-con .con {
        padding: 30px;
    }
}
</style>
